// This file is for helpers that relate to any misc helpers within the loading module

import * as R from 'ramda';

export const getActivationType = string => {
  return string
    .slice(0, -1)
    .split(/(?=[A-Z])/)
    .join('-')
    .toLowerCase();
};

export const isNotNil = R.complement(R.isNil);
